import PropTypes from "prop-types";
import CustomModal from "./CustomModal";
import { Link } from "react-router-dom";

const StatusModal = ({
  isOpen,
  onRequestClose,
  image = "/images/thumbs-up.png",
  title = "",
  description = "",
  buttonText = "Close",
  redirectTo = null,
  reload = false,
}) => {
  const handleClick = () => {
    onRequestClose();
    if (reload) window.location.reload();
  };

  const modalContent = (
    <>
      <img src={`${process.env.PUBLIC_URL}${image}`} alt={title || "Status notification"} />
      <h2 style={{ fontWeight: "500" }}>{title}</h2>
      {description && <p style={{ textAlign: "center" }}>{description}</p>}
      <button type="button" onClick={handleClick}>
        {buttonText}
      </button>
    </>
  );

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="edit-success-modal"
      contentLabel={`${title} Modal`}
    >
      {redirectTo ? (
        <Link style={{ width: "100%" }} to={redirectTo}>
          {modalContent}
        </Link>
      ) : (
        modalContent
      )}
    </CustomModal>
  );
};

StatusModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  image: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  redirectTo: PropTypes.string,
  reload: PropTypes.bool,
};

export default StatusModal;
